'use client'

import { LayoutGroup } from 'motion/react'

import type { EmojiName } from '@portal/news-lib/emoji'

import { EmojiButton } from './ui/emoji-button'
import styles from './view.module.css'

export type ReactionListProps = {
    reactions: { name: EmojiName; count: number }[]
    checkedEmojiName: EmojiName | ''
    onClick: (emojiName: EmojiName, position: { x: number; y: number }) => void
}

export function ReactionList(props: ReactionListProps) {
    const { reactions, onClick, checkedEmojiName } = props

    return (
        <div className={styles.emojiRow}>
            <LayoutGroup>
                {reactions.map(({ name, count }) => (
                    <EmojiButton
                        key={name}
                        name={name}
                        count={count}
                        isChecked={name === checkedEmojiName}
                        onClick={(position) => onClick(name, position)}
                    />
                ))}
            </LayoutGroup>
        </div>
    )
}
